import React from 'react';
import { Modal } from '../../components/ui';
import { yesNo, activeOptions } from './useUserManagement';

// Add/Edit user dialog — desktop. 640px wide: names on one line, contact +
// password on the next (each box as wide as what goes in it), the three
// switches as segmented buttons. Enter in a text box saves. Logic: useUserManagement.
const Seg = ({ label, value, options, onChange }) => (
  <div className="pp-seg-field">{label}
    <div className="pp-seg">
      {options.map(o => (
        <button key={o.value} type="button" className={String(value) === o.value ? 'on' : ''} onClick={() => onChange(o.value)}>{o.label}</button>
      ))}
    </div>
  </div>
);

export default function UserEditFormDesktop({ vm }) {
  const { editing, form, setF, saving, close, save } = vm;
  const onEnter = (e) => { if (e.key === 'Enter' && !saving) { e.preventDefault(); save(); } };
  const text = (k) => ({ value: form[k] ?? '', onChange: (e) => setF(k, e.target.value), onKeyDown: onEnter });
  return (
    <Modal
      className="pp-um-modal"
      title={editing ? 'Edit User' : 'Add User'}
      onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <div className="pp-row pp-um-names">
        <label className="field">Surname<input {...text('Surname')} /></label>
        <label className="field">Name *<input autoFocus {...text('Name')} /></label>
        <label className="field">Father / Husband<input {...text('FatherHusband')} /></label>
      </div>
      <div className="pp-row pp-um-contact">
        <label className="field">Mobile Number *<input inputMode="numeric" placeholder="10 digits" {...text('MobileNumber')} /></label>
        <label className="field">Email<input type="email" {...text('EmailId')} /></label>
        <label className="field">{editing ? 'New Password' : 'Password *'}
          <input type="password" autoComplete="new-password" placeholder={editing ? 'Leave blank to keep' : ''} {...text('Password')} />
        </label>
      </div>
      <div className="pp-um-flags">
        <Seg label="Super Admin" value={form.SuperAdmin} options={yesNo} onChange={v => setF('SuperAdmin', v)} />
        <Seg label="Allow Mobile Login" value={form.AllowUserMobile} options={yesNo} onChange={v => setF('AllowUserMobile', v)} />
        <Seg label="Status" value={form.IsActive} options={activeOptions} onChange={v => setF('IsActive', v)} />
      </div>
    </Modal>
  );
}
